import { controls,grouped } from "../controls";
const limits = {
label: "Limits",
pageLabel: "Limits",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "Start Dow"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "start_dow",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "End Dow"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "end_dow",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "filter", label: "Start Dom"}),
...controls.numberOnly({ tab: "filter",  placeHolder: "", name: "start_dom",maxlength:200}),
...controls.displayText({ tab: "filter", label: "",width:"col-sm-2"}),
]
,form:[
...controls.displayText({ tab: "general", label: "Start Dow",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "start_dow",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "End Dow",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "end_dow",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Start Dom",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "start_dom",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "End Dom",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "end_dom",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Start Month",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "start_month",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "End Month",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "end_month",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "From Time",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "from_time",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "To Time",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "to_time",isRequired:false,maxlength:50}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Is Lifetime Limit",default:false, name: "is_lifetime_limit" }),
...controls.displayText({ tab: "general", label: "Transaction Type",star:false}),
...controls.oc({ tab: "general", c: "TransactionType", placeHolder: "Transaction Type Code", name: "transaction_type_code", isRequired:false,fastpath:"transaction_types"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "transaction_type_display"}),
...controls.displayText({ tab: "general", label: "Amount"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "amount",maxlength:16}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.displayText({ tab: "general", label: "Frequency",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "frequency",isRequired:false,maxlength:200}),
...controls.displayText({ tab: "general", label: "",width:"col-sm-2"}),
...controls.checkBox({ tab: "general", label: "Can Create New",default:false, name: "can_create_new" }),
...controls.checkBox({ tab: "general", label: "Can Update",default:false, name: "can_update" }),
...controls.checkBox({ tab: "general", label: "Can Delete",default:false, name: "can_delete" }),
...controls.checkBox({ tab: "general", label: "Can Auth",default:false, name: "can_auth" }),
...controls.checkBox({ tab: "general", label: "Can Print",default:false, name: "can_print" }),
...controls.checkBox({ tab: "general", label: "Can Export",default:false, name: "can_export" }),
...controls.checkBox({ tab: "general", label: "Can Share",default:false, name: "can_share" }),
...controls.displayText({ tab: "general", label: "Form",star:false}),
...controls.oc({ tab: "general", c: "Form", placeHolder: "Form Code", name: "form_code", isRequired:false,fastpath:"forms"}),
...controls.showData({ tab: "general", displaytype: "capital", data: "form_display"}),
]
,history:{
perPage: 10,
reportHeader: "Limits",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Start Dow",accessor: "start_dow",},
{Header: "End Dow",accessor: "end_dow",},
{Header: "Start Dom",accessor: "start_dom",},
]}};
export default limits;